import { Helper } from '@/mixin/helper'
import { hasLineOrderFeatureAccess } from '@/helpers/tms-line-order'

const translate = (t, key, fallback) => {
  if (typeof t !== 'function') return fallback

  const translated = t(key)

  return translated === key ? fallback : translated
}

export const getReadOnlyDeliveryItems = (t) => [
  {
    key: 'deliveryType',
    label: translate(t, 'delivery.fields.deliveryType', 'Tipe Pengiriman'),
    value: '-',
    defaultValue: '-',
    bold: true,
  },
  {
    key: 'lineOrder',
    label: translate(t, 'delivery.fields.lineOrder', 'Line Order'),
    value: '-',
    defaultValue: '-',
    bold: false,
    showComponent: hasLineOrderFeatureAccess() ? true : false,
  },
  {
    key: 'deliveryNumber',
    label: translate(t, 'delivery.fields.deliveryNumber', 'No. Pengiriman'),
    value: translate(t, 'delivery.fields.autoAppear', 'Otomatis Terbit'),
    defaultValue: translate(t, 'delivery.fields.autoAppear', 'Otomatis Terbit'),
    bold: false,
  },
  {
    key: 'refOrder',
    label: translate(t, 'delivery.fields.refOrder', 'Ref. Order'),
    value: translate(t, 'delivery.fields.fromOrder', 'Dari Order'),
    defaultValue: translate(t, 'delivery.fields.fromOrder', 'Dari Order'),
    bold: false,
    scopes: [
      'tms-integration-accurate:create',
      'tms-integration-accurate:read',
      'tms-integration-accurate:delete',
      'tms-integration-accurate:update',
    ],
  },
  {
    key: 'fleetTaskNumber',
    label: translate(t, 'delivery.fields.fleetTaskNumber', 'No. Penugasan'),
    value: '-',
    defaultValue: '-',
    bold: false,
    primaryText: true,
  },
  {
    key: 'createdDate',
    label: translate(t, 'delivery.fields.createdDate', 'Tanggal Dibuat'),
    value: translate(t, 'delivery.fields.autoAppear', 'Otomatis Terbit'),
    defaultValue: translate(t, 'delivery.fields.autoAppear', 'Otomatis Terbit'),
    bold: false,
  },
  {
    key: 'createdBy',
    label: translate(t, 'delivery.fields.createdBy', 'Dibuat Oleh'),
    value: Helper.methods.getUserName(),
    bold: true,
  },
  {
    key: 'invoiceNumber',
    label: translate(t, 'invoice.fields.invoiceNumber', 'No. Invoice'),
    value: '-',
    defaultValue: '-',
    bold: false,
    showComponent: true,
    component: () => import('@/router/views/delivery/components/Provider/DeleteInvoice'),
  },
]

export const getReadOnlyOriginLocationItems = (t) => [
  {
    key: 'city',
    label: translate(t, 'master.form.address.city', 'Kota'),
    value: translate(t, 'delivery.placeholder.originAddress', 'Pilih Alamat Asal'),
    defaultValue: translate(t, 'delivery.placeholder.originAddress', 'Pilih Alamat Asal'),
    bold: false,
  },
  {
    key: 'operationalTime',
    label: translate(t, 'master.form.customer.operationalTime', 'Waktu Operasional'),
    value: translate(t, 'delivery.placeholder.originAddress', 'Pilih Alamat Asal'),
    defaultValue: translate(t, 'delivery.placeholder.originAddress', 'Pilih Alamat Asal'),
    bold: false,
  },
  {
    key: 'breakTime',
    label: translate(t, 'master.form.customer.breakTime', 'Waktu Istirahat'),
    value: translate(t, 'delivery.placeholder.originAddress', 'Pilih Alamat Asal'),
    defaultValue: translate(t, 'delivery.placeholder.originAddress', 'Pilih Alamat Asal'),
    bold: false,
  },
]

export const getReadOnlyDeliveryLocationItems = (t) => [
  {
    key: 'city',
    label: translate(t, 'master.form.address.city', 'Kota'),
    value: translate(t, 'delivery.placeholder.destinationAddress', 'Pilih Alamat Tujuan'),
    defaultValue: translate(t, 'delivery.placeholder.destinationAddress', 'Pilih Alamat Tujuan'),
    bold: false,
  },
  {
    key: 'operationalTime',
    label: translate(t, 'master.form.customer.operationalTime', 'Waktu Operasional'),
    value: translate(t, 'delivery.placeholder.destinationAddress', 'Pilih Alamat Tujuan'),
    defaultValue: translate(t, 'delivery.placeholder.destinationAddress', 'Pilih Alamat Tujuan'),
    bold: false,
  },
  {
    key: 'breakTime',
    label: translate(t, 'master.form.customer.breakTime', 'Waktu Istirahat'),
    value: translate(t, 'delivery.placeholder.destinationAddress', 'Pilih Alamat Tujuan'),
    defaultValue: translate(t, 'delivery.placeholder.destinationAddress', 'Pilih Alamat Tujuan'),
    bold: false,
  },
]
